var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"center"},[_c('div',{staticClass:"emoji animated infinite tada"},[_vm._v("🍤")]),_vm._v("\n  Oh no! Krill is lost.\n")])}]

export { render, staticRenderFns }